import IWithdrawalLayer from "./IWithdrawalLayer";
import NetworkLogic from "../../Shared/NetworkLogic";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WithdrawalRecordLayer extends IWithdrawalLayer {
    @property(cc.Layout)
    lytContent: cc.Layout = null

    @property(cc.Node)
    nodeTemplateItem: cc.Node = null

    @property(cc.Node)
    nodeEmpty: cc.Node = null

    onLoad () {
        this.nodeTemplateItem.parent = null
        this.nodeEmpty.active = false
    }

    start () {
        NetworkLogic.getWithdrawList(1, 1000, 5, function (data) {
            if (data.length > 0) {
                this.nodeEmpty.active = false
                this.createItems(data)
            }else {
                this.nodeEmpty.active = true
            }
        }.bind(this))
    }

    onDestroy () {
        this.nodeTemplateItem.destroy()
    }

    createItems(data) {
        data.forEach(item => {
            let node = cc.instantiate(this.nodeTemplateItem)
            node.parent = this.lytContent.node

            node["msgData"] = item
            node.getChildByName("time").getComponent(cc.Label).string = item["timeCreated"]
            node.getChildByName("money").getComponent(cc.Label).string = item["changeCoin"]
            node.getChildByName("state").getComponent(cc.Label).string = item["flagName"]
            node.getChildByName("info").getComponent(cc.Label).string = item["opRemark"]
        });
    }
}
